export default "__VITE_ASSET__C14wSC$g__"